import React, { Component } from 'react';
import {
  Button,
  Layout,
  Row,
  Col,
  Typography,
  Modal,
  message,
  Carousel,
} from 'antd';
import { FiExternalLink } from 'react-icons/fi';
import './gettingStarted.css';
import queryString from 'query-string';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DemoChannelDefaults from '../jira/jiraConnectionFlow/defaultChannelSelection';
import ConfigureWikiChannelModal from '../confluence/ConfigureWikiChannelModal';
import Setup_demo_helpdesk_channels from '../../../media/Getting started page media/Helpdesk onboarding Modal illustrations/1. Setup demo Helpdesk channels.svg';
import Check_update_in_support_channe from '../../../media/Getting started page media/Helpdesk onboarding Modal illustrations/2. Check update in support channel.svg';
import InAppHome from '../../../media/Getting started page media/Helpdesk onboarding Modal illustrations/3. In App Home.svg';
import InDMWithAgents from '../../../media/Getting started page media/Helpdesk onboarding Modal illustrations/4. In DM with agents.svg';
import ManageApprovals from '../../../media/Getting started page media/Helpdesk onboarding Modal illustrations/5. Manage approvals.svg';
import CreateApprovalRequest from '../../../media/Getting started page media/Helpdesk onboarding Modal illustrations/6. Create approval request.svg';
import GetNotifiedAndTakeAction from '../../../media/Getting started page media/Helpdesk onboarding Modal illustrations/7. Get notified and take action.svg';
import Setup_demo_project_channels from '../../../media/Getting started page media/Project onboarding illustration/1.Setup demo project channel.svg';
import IssueCard from '../../../media/Getting started page media/Project onboarding illustration/2. Issue card.svg';
import Setup_demo_wiki_channels from '../../../media/Getting started page media/wiki onboarding illustrations/1. Setup demo wiki channels.svg';
import Add_to_confluence from '../../../media/Getting started page media/wiki onboarding illustrations/2. Add to Confluence.svg';
import Submit_1st_standup from '../../../media/Getting started page media/Check-ins onboarding illustrations/2. Submit 1st standup answer.svg';
import Integrate_with_jira from '../../../media/Getting started page media/Check-ins onboarding illustrations/3. Integrate with Jira.svg';
import Share_jira_context_in_reports from '../../../media/Getting started page media/Check-ins onboarding illustrations/4. Share Jira context in reports.svg';
import SuccessCustomEmoji from '../../../media/Getting started page media/Helpdesk onboarding Emoji/1. Success.svg';
import ManagePrivateRequestsEmoji from '../../../media/Getting started page media/Helpdesk onboarding Emoji/2. Manage private requests.svg';
// import HurrayCustomEmoji from '../../../media/Getting started page media/Helpdesk onboarding Emoji/3. Hurray, you made it.svg';

const { Text } = Typography;

class ModalContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiLoading: false,
      dummyCount: 0,
      demoChannelsData: null,
    };

    this.carouselRef = React.createRef();
  }

  componentDidMount() {
    const parsedQueryString = queryString.parse(this.props.location.search);
    if (
      parsedQueryString &&
      Object.keys(parsedQueryString).length > 0 &&
      (!parsedQueryString.product || !parsedQueryString.step)
    ) {
      message.error('An unexpected error happened!');
      this.props.history.push(`/${this.props.match.params.wId}/dashboard`);
      return;
    }
  }

  acceptMethods(invokeChildMethod) {
    this.invokeChildMethod = invokeChildMethod;
  }

  handlePreviousClick = () => {
    const { product, step, page } = queryString.parse(
      this.props.location.search
    );

    if (product === 'helpdesk' && step === 'setup_demo_channels') {
      if (
        page === '2' ||
        page === '3' ||
        page === '4' ||
        page === '5' ||
        page === '6'
      ) {
        let prevPage = Number(page) - 1;
        this.props.history.push(
          `/${this.props.match.params.wId}/getting_started?product=${product}&step=${step}&page=${prevPage}`
        );
      }
    } else if (
      product === 'projects' &&
      step === 'setup_demo_project_channel' &&
      (page === '2' || page === '3' || page === '4' || page === '5')
    ) {
      let prevPage = Number(page) - 1;
      this.props.history.push(
        `/${this.props.match.params.wId}/getting_started?product=${product}&step=${step}&page=${prevPage}`
      );
    } else if (
      product === 'wiki' &&
      step === 'setup_demo_wiki_channel' &&
      (page === '2' || page === '3' || page === '4')
    ) {
      let prevPage = Number(page) - 1;
      this.props.history.push(
        `/${this.props.match.params.wId}/getting_started?product=${product}&step=${step}&page=${prevPage}`
      );
    } else this.carouselRef.current.prev();
  };

  validateStepContents = ({ currentSlide }) => {
    const { product, step, page } = queryString.parse(
      this.props.location.search
    );

    if (this.isLastPage()) {
      this.props.handleStepDone({ product, stepKey: step });
      this.props.history.push(
        `/${this.props.match.params.wId}/getting_started`
      );
    } else if (product === 'helpdesk' && step === 'setup_demo_channels') {
      if (page === '1' || page === '3' || page === '4' || page === '5') {
        let nextPage = Number(page) + 1;
        this.props.history.push(
          `/${this.props.match.params.wId}/getting_started?product=${product}&step=${step}&page=${nextPage}`
        );
      } else if (page === '2') {
        this.invokeChildMethod();
      } else if (page === '6')
        this.props.history.push(
          `/${this.props.match.params.wId}/getting_started`
        );
    } else if (
      product === 'projects' &&
      step === 'setup_demo_project_channel'
    ) {
      if (page === '1' || page === '3' || page === '4') {
        let nextPage = Number(page) + 1;
        this.props.history.push(
          `/${this.props.match.params.wId}/getting_started?product=${product}&step=${step}&page=${nextPage}`
        );
      } else if (page === '2') {
        this.invokeChildMethod();
      } else if (page === '5')
        this.props.history.push(
          `/${this.props.match.params.wId}/getting_started`
        );
    } else if (product === 'wiki' && step === 'setup_demo_wiki_channel') {
      if (page === '1' || page === '3') {
        let nextPage = Number(page) + 1;
        this.props.history.push(
          `/${this.props.match.params.wId}/getting_started?product=${product}&step=${step}&page=${nextPage}`
        );
      } else if (page === '2') {
        this.createDemoWikiChannel();
      } else if (page === '4')
        this.props.history.push(
          `/${this.props.match.params.wId}/getting_started`
        );
    } else {
      this.carouselRef.current.next();
    }
  };

  moveToNextStep(data) {
    const { product, step, page } = queryString.parse(
      this.props.location.search
    );

    if (data) this.setState({ demoChannelsData: data });

    const currentSlide =
      this.carouselRef &&
      this.carouselRef.current &&
      this.carouselRef.current.innerSlider &&
      this.carouselRef.current.innerSlider.state.currentSlide;

    if (
      (product === 'helpdesk' &&
        step === 'setup_demo_channels' &&
        page === '2') ||
      (product === 'projects' &&
        step === 'setup_demo_project_channel' &&
        page === '2') ||
      (product === 'wiki' && step === 'setup_demo_wiki_channel' && page === '2')
    ) {
      this.props.history.push(
        `/${this.props.match.params.wId}/getting_started?product=${product}&step=${step}&page=3`
      );
    }
  }
  isLastPage = () => {
    const { product, step, page } = queryString.parse(
      this.props.location.search
    );
    const currentSlide =
      this.carouselRef &&
      this.carouselRef.current &&
      this.carouselRef.current.innerSlider &&
      this.carouselRef.current.innerSlider.state.currentSlide;
    let isLastPage = false;

    if (product === 'helpdesk') {
      if (
        (step === 'setup_demo_channels' && page === '6') ||
        step === 'customize_support_channel' ||
        step === 'customize_agent_channel' ||
        (step === 'manage_private_requests' && currentSlide === 3) ||
        (step === 'manage_approvals' && currentSlide === 2)
      )
        isLastPage = true;
    } else if (product === 'projects') {
      if (
        (step === 'setup_demo_project_channel' && page === '5') ||
        (step === 'issue_card_customization' && currentSlide === 1) ||
        (step === 'customize_creation_form' && currentSlide === 1) ||
        step === 'customize_personal_notification' ||
        step === 'commands' ||
        step === 'emoji_actions'
      )
        isLastPage = true;
    } else if (product === 'wiki') {
      if (step === 'setup_demo_wiki_channel' && page === '4') isLastPage = true;
      else if (step === 'add_to_confluence' && currentSlide === 1)
        isLastPage = true;
      else if (step === 'search_an_article_privately') isLastPage = true;
    } else if (product === 'reports') {
      if (
        step === 'setup_chart_report' ||
        step === 'setup_issue_list_report' ||
        step === 'setup_custom_report' ||
        step === 'setup_personal_report'
      )
        isLastPage = true;
    } else if (
      product === 'checkins' &&
      (step === 'setup_standup_checkin' ||
        step === 'submit_standup_answer' ||
        step === 'integrate_with_jira' ||
        step === 'unfurl_jira_issue_mentions')
    )
      isLastPage = true;

    return isLastPage;
  };

  getFooterButtons = () => {
    const { apiLoading } = this.state;
    const { product, step, page } = queryString.parse(
      this.props.location.search
    );

    const currentSlide =
      this.carouselRef &&
      this.carouselRef.current &&
      this.carouselRef.current.innerSlider &&
      this.carouselRef.current.innerSlider.state.currentSlide;
    let showPreviousButton = false;

    if (
      product === 'helpdesk' &&
      ((step === 'setup_demo_channels' && page === '1') ||
        step === 'customize_support_channel' ||
        step === 'customize_agent_channel')
    )
      showPreviousButton = false;
    else if (
      product === 'helpdesk' &&
      step === 'setup_demo_channels' &&
      page !== '1'
    )
      showPreviousButton = true; //  TO HANDLE MULTIPLE PAGES WITH OUT CAROUSEL
    else if (
      product === 'projects' &&
      step === 'setup_demo_project_channel' &&
      page === '1'
    )
      showPreviousButton = false;
    else if (
      product === 'projects' &&
      step === 'setup_demo_project_channel' &&
      page !== '1'
    )
      showPreviousButton = true; //  TO HANDLE MULTIPLE PAGES WITH OUT CAROUSEL
    else if (
      product === 'wiki' &&
      step === 'setup_demo_wiki_channel' &&
      page === '1'
    )
      showPreviousButton = false;
    else if (
      product === 'wiki' &&
      ((step === 'setup_demo_wiki_channel' && page !== '1') ||
        (step === 'add_to_confluence' && currentSlide === 1))
    )
      showPreviousButton = true; //  TO HANDLE MULTIPLE PAGES WITH OUT CAROUSEL
    else if (product === 'wiki' && step === 'search_an_article_privately')
      showPreviousButton = false;
    else if (
      product === 'reports' &&
      (step === 'setup_chart_report' ||
        step === 'setup_issue_list_report' ||
        step === 'setup_custom_report' ||
        step === 'setup_personal_report')
    )
      showPreviousButton = false;
    else if (
      product === 'checkins' &&
      (step === 'setup_standup_checkin' ||
        step === 'submit_standup_answer' ||
        step === 'integrate_with_jira' ||
        step === 'unfurl_jira_issue_mentions')
    )
      showPreviousButton = false;
    else if (currentSlide === 0 || currentSlide === null)
      showPreviousButton = false;
    else showPreviousButton = true;

    let buttonsArray = [
      <>
        {showPreviousButton && (
          <Button
            style={{ width: 100 }}
            onClick={() => {
              this.handlePreviousClick({
                currentSlide,
              });
            }}
          >
            Previous
          </Button>
        )}
        <Button
          type='primary'
          style={{ width: 100 }}
          loading={apiLoading}
          onClick={() => {
            this.validateStepContents({
              currentSlide,
            });
          }}
        >
          {this.isLastPage() ? 'Done' : 'Next'}
        </Button>
      </>,
    ];

    return buttonsArray;
  };

  setParentLoadingState = (loadingState) => {
    this.setState({ apiLoading: loadingState });
  };

  forseUpdateComponenetes = () => {
    this.forceUpdate(); // ON CAROUSEL NEXT/PREV COMPONENET NOT RENDERED AGAIN, SO WE ARE FORCE RERENDERING TO UPDATE THE MODAL FOOTER CONTENT
  };

  render() {
    const { product, step, page } = queryString.parse(
      this.props.location.search
    );
    const { skills } = this.props;
    const { demoChannelsData } = this.state;
    const jiraSkill = skills && skills.find((skill) => skill.name === 'Jira');
    const wikiSkill = skills && skills.find((skill) => skill.key === 'wiki');
    const gutterSize = 24;
    return (
      <Modal
        visible={product && step}
        // okText='Next' cancelText='Skip'
        maskClosable={false}
        keyboard={false}
        closable={true}
        destroyOnClose
        footer={this.getFooterButtons()}
        onCancel={() => {
          this.props.history.push(
            `/${this.props.match.params.wId}/getting_started`
          );
        }}
        width={841}
        bodyStyle={{ height: 400 }}
      >
        {product === 'helpdesk' && step === 'setup_demo_channels' && (
          <div>
            {page === '1' && (
              <div class='defualt-container'>
                <Row gutter={gutterSize} align='middle'>
                  <Col span={12}>
                    <div class='modal-title-font'>
                      <Text strong>Setup demo Helpdesk channels</Text>
                    </div>
                    <div class='margin-bottom-8'>
                      <Text>This will create 2 demo helpdesk channels. </Text>
                    </div>
                    <ol class='modal-list ol-custom-spacing'>
                      <li>
                        Support channel - a public channel for employees to
                        report requests.
                      </li>
                      <li>
                        Agent channel - a private channel for help desk team to
                        triage requests.
                      </li>
                    </ol>
                    <div>
                      <Text>Click next to connect a JSM project.</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <img
                      src={Setup_demo_helpdesk_channels}
                      class='img-width'
                    ></img>
                  </Col>
                </Row>
              </div>
            )}
            {page === '2' && (
              <div>
                <div class='modal-title-font' style={{ marginBottom: 24 }}>
                  <Text strong>Connect JSM project</Text>
                </div>
                {jiraSkill && (
                  <div>
                    <DemoChannelDefaults
                      data={{
                        channelDefaults: { id: '', channelName: '' },
                        channelInfo: false,
                        domain: { done: false, domain: '' },
                        linking: {
                          autoCreateFields: {},
                          channel: { done: true, id: '', name: '' },
                          done: false,
                          issueType: {},
                          project: {},
                        },
                        skill_id: jiraSkill.skill_metadata._id,
                        token: { done: false, userName: '', userToken: '' },
                      }}
                      moveToNextStep={(data) => {
                        this.moveToNextStep(data);
                      }}
                      setLoadingState={(loadingState) => {
                        this.setParentLoadingState(loadingState);
                      }}
                      shareMethods={this.acceptMethods.bind(this)}
                      skill_id={jiraSkill.skill_metadata._id}
                      linkProjectErrorMessageHandle={() => {}}
                      default_type='helpdesk_channels'
                    />
                    <div>
                      <Text>
                        The default request type will be used when creating
                        requests automatically from messages posted in the
                        channel or when ticket emoji is added to messages.
                      </Text>
                    </div>
                  </div>
                )}
              </div>
            )}
            {page === '3' && (
              <div>
                <div class='modal-title-font'>
                  <Text strong>Success!</Text>
                </div>
                <div style={{ textAlign: 'center', margin: '60px 150px' }}>
                  <img
                    src={SuccessCustomEmoji}
                    style={{ margin: 'auto', marginBottom: '20px' }}
                  />
                  <div class='margin-bottom-8'>
                    {demoChannelsData && (
                      <div>
                        <div style={{ marginBottom: 15 }}>
                          <Text strong>
                            Congratulations on successfully setting up your
                            HelpDesk channels.{' '}
                            <a
                              onClick={() =>
                                window.open(
                                  `https://slack.com/app_redirect?team=${this.props.team.id}&channel=${demoChannelsData.helpdeskChannels.agentChannelData.id}`,
                                  '_blank'
                                )
                              }
                            >
                              #
                              {
                                demoChannelsData.helpdeskChannels
                                  .agentChannelData.name
                              }
                            </a>{' '}
                            &{' '}
                            <a
                              onClick={() =>
                                window.open(
                                  `https://slack.com/app_redirect?team=${this.props.team.id}&channel=${demoChannelsData.helpdeskChannels.supportChannelData.id}`,
                                  '_blank'
                                )
                              }
                            >
                              #
                              {
                                demoChannelsData.helpdeskChannels
                                  .supportChannelData.name
                              }
                            </a>{' '}
                          </Text>
                        </div>
                        <div style={{ marginBottom: 15 }}>
                          <Text>
                            Click here to customize{' '}
                            <a
                              onClick={() =>
                                this.props.history.push(
                                  `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_service_desk?view=channel_preferences&channel_name=${demoChannelsData.helpdeskChannels.agentChannelData.name}&channel_id=${demoChannelsData.helpdeskChannels.agentChannelData.id}&channel_type=agent`
                                )
                              }
                            >
                              agent channel
                            </a>{' '}
                            and{' '}
                            <a
                              onClick={() =>
                                this.props.history.push(
                                  `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_service_desk?view=channel_preferences&channel_name=${demoChannelsData.helpdeskChannels.supportChannelData.name}&channel_id=${demoChannelsData.helpdeskChannels.supportChannelData.id}&channel_type=support`
                                )
                              }
                            >
                              support channel
                            </a>{' '}
                            behavior.
                          </Text>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    <Text>
                      Click next to see how you can test in these channels.
                    </Text>
                  </div>
                </div>
              </div>
            )}
            {page === '4' && (
              <div class='defualt-container'>
                <Row gutter={gutterSize} align='middle'>
                  <Col span={12}>
                    <div class='modal-title-font'>
                      <Text strong>Create request in support channel</Text>
                    </div>
                    <ol class='modal-list ol-custom-spacing'>
                      <li>
                        Go to the support channel in Slack and post a message.
                      </li>
                      <li>Drop the ‘ticket’ emoji on the message.</li>
                      <li>
                        This will create a new request in the connected Jira
                        project.{' '}
                      </li>
                      <li>
                        Click on the thread to see the Slack message containing
                        the ticket information.{' '}
                      </li>
                    </ol>
                  </Col>
                  <Col span={12}>
                    <Layout class='video-layout'>
                      <div class='video-container'>
                        <iframe
                          src='https://www.youtube.com/embed/rt2Ac9qhhTw'
                          title='YouTube video player'
                          frameborder='0'
                          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                          allowFullScreen
                          class='video-content'
                        ></iframe>
                      </div>
                    </Layout>
                  </Col>
                </Row>
              </div>
            )}
            {page === '5' && (
              <div class='defualt-container'>
                <Row gutter={gutterSize} align='middle'>
                  <Col span={12}>
                    <div class='modal-title-font'>
                      <Text strong>
                        Assign and update request in agent channel
                      </Text>
                    </div>

                    <ol class='modal-list ol-custom-spacing'>
                      <li>
                        Go to the agent channel in Slack and you can find the
                        Troopr message for the request created from the support
                        channel.
                      </li>
                      <li>
                        Open the thread, click on ‘Assign to me’ under ‘Select
                        an action’.
                      </li>
                      <li>Now post a solution in the thread.</li>
                      <li>Update the status to Done.</li>
                    </ol>
                  </Col>
                  <Col span={12}>
                    <Layout class='video-layout'>
                      <div class='video-container'>
                        <iframe
                          src='https://www.youtube.com/embed/uTBjlELgFUY'
                          title='YouTube video player'
                          frameborder='0'
                          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                          allowFullScreen
                          class='video-content'
                        ></iframe>
                      </div>
                    </Layout>
                  </Col>
                </Row>
              </div>
            )}
            {page === '6' && (
              <div>
                {jiraSkill &&
                (jiraSkill.skill_metadata.metadata.server_type ===
                  'jira_server_oauth' ||
                  jiraSkill.skill_metadata.metadata.server_type ===
                    'jira_server') ? (
                  <div class='defualt-container'>
                    <Row gutter={gutterSize} align='middle'>
                      <Col span={12}>
                        <div class='modal-title-font'>
                          <Text strong>Check update in support channel</Text>
                        </div>
                        <div>
                          <Text>
                            Head over to the support channel, open the ticket
                            thread to see the updates.
                          </Text>
                        </div>
                      </Col>
                      <Col span={12}>
                        <img
                          src={Check_update_in_support_channe}
                          class='img-width'
                        ></img>
                      </Col>
                    </Row>
                  </div>
                ) : (
                  <div class='defualt-container'>
                    <Row gutter={gutterSize} align='middle'>
                      <Col span={12}>
                        <div class='modal-title-font'>
                          <Text strong>Submit feedback</Text>
                        </div>
                        <div class='margin-bottom-8'>
                          <Text>
                            When a request is closed, Troopr will send the
                            feedback request to the requestor.
                          </Text>
                        </div>
                        <ol class='modal-list ol-custom-spacing'>
                          <li>Go to Troopr Assistant app messages in Slack.</li>
                          <li>Find the CSAT request message.</li>
                          <li>Click on an emoji to submit feedback.</li>
                        </ol>
                        <div>
                          <Text>
                            This feedback is synced into the Jira request.{' '}
                          </Text>
                        </div>
                      </Col>
                      <Col span={12}>
                        <Layout class='video-layout'>
                          <div class='video-container'>
                            <iframe
                              src='https://www.youtube.com/embed/Tm2qJQ6Hjho'
                              title='YouTube video player'
                              frameborder='0'
                              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                              allowFullScreen
                              class='video-content'
                            ></iframe>
                          </div>
                        </Layout>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {product === 'helpdesk' && step === 'customize_support_channel' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Customize support channel</Text>
                </div>
                <ol class='modal-list ol-custom-spacing'>
                  <li>
                    Go to ‘Channel preferences’ under HelpDesk in Troopr webapp.
                  </li>
                  <li>Click on any support channel you created.</li>
                  <li>
                    Under ‘Auto create’ choose ‘For every message posted’.
                  </li>
                  <li>
                    Send a message in the support channel, it automatically gets
                    converted into a Jira request.
                  </li>
                </ol>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/Yvv-PO4t_o8'
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}
        {product === 'helpdesk' && step === 'customize_agent_channel' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Customize agent channel</Text>
                </div>
                <ol class='modal-list ol-custom-spacing'>
                  <li>
                    Go to any agent channel in ‘Channel preferences’ under
                    HelpDesk in Troopr webapp.
                  </li>
                  <li>
                    Under ‘Issue card customization’ click on ‘Customize’.{' '}
                  </li>
                  <li>In the model, go to the ‘Action’ tab.</li>
                  <li>
                    Change Button #3 Name from ‘Comment’ to ‘Assign to me’ and
                    select ‘Assign to me’ in the Button #3 Action dropdown and
                    save.
                  </li>
                </ol>
                <div>
                  <Text>
                    Now, every time a request is created, it will have the
                    ‘Assign to me’ button in the agent channel.
                  </Text>
                </div>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/ZuBADZmEraY'
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}
        {product === 'helpdesk' && step === 'manage_private_requests' && (
          <Carousel
            ref={this.carouselRef}
            dots={false}
            afterChange={() => this.forseUpdateComponenetes()}
          >
            <div>
              <div class='modal-title-font'>
                <Text strong>Manage private requests</Text>
              </div>
              <div style={{ margin: '40px 165px' }}>
                <div style={{ marginBottom: '20px' }}>
                  <img
                    src={ManagePrivateRequestsEmoji}
                    style={{ margin: 'auto', marginBottom: 40 }}
                  />
                  <div class='margin-bottom-8' style={{ textAlign: 'center' }}>
                    <Text strong>
                      All requests including ones submitted in public support
                      channels or privately or from Jira will be tracked in
                      agent channels.
                    </Text>
                  </div>
                </div>
                <div style={{ textAlign: 'center' }} class='margin-bottom-8'>
                  <Text>Ways to manage requests privately:</Text>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <ol style={{ marginLeft: '-50px' }} class='ol-custom-spacing'>
                    <li>In Troopr Apphome</li>
                    <li>In DM with agents</li>
                    <li>Converting a public request</li>
                  </ol>
                </div>
              </div>
            </div>
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>In Troopr Apphome</Text>
                  </div>
                  <div class='margin-bottom-8'>
                    <Text>
                      You can create requests privately in Slack by clicking on
                      the +Request button in Troopr Assistant home.
                    </Text>
                  </div>
                </Col>
                <Col span={12}>
                  <img src={InAppHome} class='img-width'></img>
                </Col>
              </Row>
            </div>
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='margin-bottom-8'>
                    <Text strong>In DM with agents</Text>
                  </div>
                  <div class='margin-bottom-8'>
                    <Text>
                      Agents can handle requests from employees in direct chat.
                    </Text>
                  </div>
                  <ol class='modal-list ol-custom-spacing'>
                    <li>
                      Enable "Use Troopr in DM channels" section in ‘Personal
                      Preferences’ under HelpDesk in Troopr Webapp .
                    </li>
                    <li>
                      Click on “More actions” and select "Task It" on user’s
                      message.
                    </li>
                    <li>The message will be converted into a Jira request.</li>
                  </ol>
                </Col>
                <Col span={12}>
                  <img src={InDMWithAgents} class='img-width'></img>
                </Col>
              </Row>
            </div>
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Converting a public request</Text>
                  </div>
                  <div class='margin-bottom-8'>
                    <Text>
                      Convert a request in a public channel to a private
                      discussion using the ‘Discuss in private’ option.
                    </Text>
                  </div>
                  <ol class='modal-list ol-custom-spacing'>
                    <li>
                      Click on it, fill the form and select ‘Make the new
                      channel private’.
                    </li>
                    <li>
                      This will create a new private channel where you can
                      discuss the issue.
                    </li>
                  </ol>
                </Col>
                <Col span={12}>
                  <Layout class='video-layout'>
                    <div class='video-container'>
                      <iframe
                        src='https://www.youtube.com/embed/BJ89_hGnqKM'
                        title='YouTube video player'
                        frameborder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        class='video-content'
                      ></iframe>
                    </div>
                  </Layout>
                </Col>
              </Row>
            </div>
          </Carousel>
        )}

        {product === 'helpdesk' && step === 'manage_approvals' && (
          <Carousel
            ref={this.carouselRef}
            dots={false}
            afterChange={() => this.forseUpdateComponenetes()}
          >
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Manage approvals</Text>
                  </div>
                  <div class='margin-bottom-8'>
                    <Text>
                      Troopr delivers approval requests to approvers in Slack.
                      Just click a button in the approval message to take action
                      on the request.
                    </Text>
                  </div>
                  <div>
                    <Text>Click next to know more.</Text>
                  </div>
                </Col>
                <Col span={12}>
                  <img src={ManageApprovals} class='img-width'></img>
                </Col>
              </Row>
            </div>
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Create approval request</Text>
                  </div>
                  <div>
                    <Text>
                      Create a new request in JSM and move it to a status that
                      requires approval. To add an approval step to a workflow-
                      read{' '}
                      <a
                        href='https://support.atlassian.com/jira-service-management-cloud/docs/add-an-approval-to-a-workflow/'
                        target={'_blank'}
                      >
                        here
                      </a>
                      .{' '}
                    </Text>
                  </div>
                </Col>
                <Col span={12}>
                  <img src={CreateApprovalRequest} class='img-width'></img>
                </Col>
              </Row>
            </div>
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Get notified and take action</Text>
                  </div>
                  <div class='margin-bottom-8'>
                    <Text>
                      If you are an approver, Troopr will send the approval
                      message to you.
                    </Text>
                  </div>
                  <ol class='modal-list ol-custom-spacing'>
                    <li>
                      Find the notification message in Troopr Assistant messages
                      in Slack.
                    </li>
                    <li>
                      Click on the ‘Approve’ button to approve the message.
                    </li>
                  </ol>
                  <div>
                    <Text>
                      The approval will be synced into the Jira request.
                    </Text>
                  </div>
                </Col>
                <Col span={12}>
                  <img src={GetNotifiedAndTakeAction} class='img-width'></img>
                </Col>
              </Row>
            </div>
          </Carousel>
        )}

        {product === 'projects' && step === 'setup_demo_project_channel' && (
          <div>
            {page === '1' && (
              <div class='defualt-container'>
                <Row gutter={gutterSize} align='middle'>
                  <Col span={12}>
                    <div class='modal-title-font'>
                      <Text strong>Setup demo project channel</Text>
                    </div>
                    <div class='margin-bottom-8'>
                      <Text>
                        This will create a demo project channel to get issue
                        previews and receive issue update alerts.
                      </Text>
                    </div>
                    <div>
                      <Text>Click next to connect a Jira project.</Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <img
                      src={Setup_demo_project_channels}
                      class='img-width'
                    ></img>
                  </Col>
                </Row>
              </div>
            )}
            {page === '2' && (
              <div>
                <div class='modal-title-font' style={{ marginBottom: 24 }}>
                  <Text strong>Connect Jira project</Text>
                </div>
                {jiraSkill && (
                  <div>
                    <DemoChannelDefaults
                      data={{
                        channelDefaults: { id: '', channelName: '' },
                        channelInfo: false,
                        domain: { done: false, domain: '' },
                        linking: {
                          autoCreateFields: {},
                          channel: { done: true, id: '', name: '' },
                          done: false,
                          issueType: {},
                          project: {},
                        },
                        skill_id: jiraSkill.skill_metadata._id,
                        token: { done: false, userName: '', userToken: '' },
                      }}
                      moveToNextStep={(data) => {
                        this.moveToNextStep(data);
                      }}
                      setLoadingState={(loadingState) => {
                        this.setParentLoadingState(loadingState);
                      }}
                      shareMethods={this.acceptMethods.bind(this)}
                      skill_id={jiraSkill.skill_metadata._id}
                      linkProjectErrorMessageHandle={() => {}}
                      default_type='project_channel'
                    />
                  </div>
                )}
                <div>
                  <Text>
                    This action will setup a demo project channel
                    #demo-troopr-project. Automatic issue creation in "Project"
                    channel will work only when summary is the only mandatory
                    field in the issue type.
                  </Text>
                </div>
              </div>
            )}
            {page === '3' && (
              <div>
                <div class='modal-title-font'>
                  <Text strong>Success!</Text>
                </div>
                <div style={{ textAlign: 'center', margin: '60px 200px' }}>
                  <img
                    src={SuccessCustomEmoji}
                    style={{ margin: 'auto', marginBottom: '20px' }}
                  />
                  <div class='margin-bottom-8'>
                    {demoChannelsData && (
                      <div>
                        <div style={{ marginBottom: 15 }}>
                          <Text strong>
                            Your channel is setup to receive real time alerts
                            about updates in{' '}
                            <a
                              onClick={() =>
                                window.open(
                                  `https://slack.com/app_redirect?team=${this.props.team.id}&channel=${demoChannelsData.channel.id}`,
                                  '_blank'
                                )
                              }
                            >
                              #{demoChannelsData.channel.name}
                            </a>{' '}
                          </Text>
                        </div>
                        <div style={{ marginBottom: 15 }}>
                          <Text>
                            Click here to customize{' '}
                            <a
                              onClick={() =>
                                this.props.history.push(
                                  `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_software?view=channel_preferences&channel_name=${demoChannelsData.channel.name}&channel_id=${demoChannelsData.channel.id}&channel_type=project`
                                )
                              }
                            >
                              project channel
                            </a>{' '}
                            behavior.
                          </Text>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    <Text>
                      Click next to see how Troopr works in this channel.{' '}
                    </Text>
                  </div>
                </div>
              </div>
            )}
            {page === '4' && (
              <div class='defualt-container'>
                <Row gutter={gutterSize} align='middle'>
                  <Col span={12}>
                    <div class='modal-title-font'>
                      <Text strong>Try issue preview</Text>
                    </div>
                    <div class='margin-bottom-8'>
                      <Text>
                        Go to the project channel in Slack, send a message with
                        the issue key in it.
                      </Text>
                    </div>
                    <div class='margin-bottom-8'>
                      <Text>Example: Who is working on TP-100? </Text>
                    </div>

                    <div>
                      <Text>
                        Troopr will automatically unfurl the issue and show the
                        issue details in a thread.
                      </Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <Layout class='video-layout'>
                      <div class='video-container'>
                        <iframe
                          src='https://www.youtube.com/embed/Tm2qJQ6Hjho'
                          title='YouTube video player'
                          frameborder='0'
                          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                          allowFullScreen
                          class='video-content'
                        ></iframe>
                      </div>
                    </Layout>
                  </Col>
                </Row>
              </div>
            )}
            {page === '5' && (
              <div class='defualt-container'>
                <Row gutter={gutterSize} align='middle'>
                  <Col span={12}>
                    <div class='modal-title-font'>
                      <Text strong>Get notifications</Text>
                    </div>
                    <ol
                      style={{ marginLeft: '-20px' }}
                      class='ol-custom-spacing'
                    >
                      <li>Open an issue in Jira.  </li>
                      <li>Add a comment to the Jira issue. </li>
                      <li>
                        Go to the project channel you created in Slack to see
                        the notification message about the changes you made in
                        Jira. 
                      </li>
                    </ol>
                  </Col>
                  <Col span={12}>
                    <Layout class='video-layout'>
                      <div class='video-container'>
                        <iframe
                          src='https://www.youtube.com/embed/Tm2qJQ6Hjho'
                          title='YouTube video player'
                          frameborder='0'
                          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                          allowFullScreen
                          class='video-content'
                        ></iframe>
                      </div>
                    </Layout>
                  </Col>
                </Row>
              </div>
            )}
          </div>
        )}

        {product === 'projects' && step === 'issue_card_customization' && (
          <Carousel
            ref={this.carouselRef}
            dots={false}
            afterChange={() => this.forseUpdateComponenetes()}
          >
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Issue card</Text>
                  </div>
                  <div class='margin-bottom-8'>
                    <Text>
                      Issue card is the Slack message sent by Troopr containing
                      information about the issue.{' '}
                    </Text>
                  </div>
                  <div>
                    <Text>
                      In this step, we will customize how the issue card will
                      look when an issue preview is generated or when an update
                      notification is sent.
                    </Text>
                  </div>
                  <div>
                    <Text>Click next to continue.</Text>
                  </div>
                </Col>
                <Col span={12}>
                  <img src={IssueCard} class='img-width'></img>
                </Col>
              </Row>
            </div>
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Steps to customize</Text>
                  </div>
                  <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                    <li>
                      Go to ‘Channel preferences’ under Projects in Troopr
                      webapp.
                    </li>
                    <li>Click on the project channel you created.</li>
                    <li>
                      Under ‘Issue card customization’ click on ‘Customize
                      buttons’.
                    </li>
                    <li>
                      Change Button #3 Name from ‘Comment’ to ‘Log time’ and
                      select ‘Log time’ in the Button #3 Action dropdown and
                      save.
                    </li>
                    <li>
                      Now, the issue card will have the ‘Log time’ button.
                    </li>
                  </ol>
                </Col>
                <Col span={12}>
                  <Layout class='video-layout'>
                    <div class='video-container'>
                      <iframe
                        src='https://www.youtube.com/embed/FGVZMNRzvHI'
                        title='YouTube video player'
                        frameborder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        class='video-content'
                      ></iframe>
                    </div>
                  </Layout>
                </Col>
              </Row>
            </div>
          </Carousel>
        )}

        {product === 'projects' &&
          step === 'customize_personal_notification' && (
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Customize personal notifications</Text>
                  </div>
                  <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                    <li>
                      Go to ‘Personal preferences’ under Projects in Troopr
                      webapp. 
                    </li>
                    <li>
                      If you haven’t verified your account, do so by clicking on
                      ‘Login to verify’.
                    </li>
                    <li>
                      Once your account is verified, enable the ‘Send
                      notifications for actions taken by self’ option and save. 
                    </li>
                    <li>
                      Now go to Jira, add a comment on any Jira issue. You will
                      get notification for the action you just completed. 
                    </li>
                  </ol>
                </Col>
                <Col span={12}>
                  <Layout class='video-layout'>
                    <div class='video-container'>
                      <iframe
                        src='https://www.youtube.com/embed/cPcZnk5jo2k'
                        title='YouTube video player'
                        frameborder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        class='video-content'
                      ></iframe>
                    </div>
                  </Layout>
                </Col>
              </Row>
            </div>
          )}

        {product === 'projects' && step === 'customize_creation_form' && (
          <Carousel
            ref={this.carouselRef}
            dots={false}
            afterChange={() => this.forseUpdateComponenetes()}
          >
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Customize creation form</Text>
                  </div>
                  <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                    <li>
                      Go to ‘Channel preferences’ under Projects in Troopr
                      webapp. 
                    </li>
                    <li>Click on the project channel you created. </li>
                    <li>Click on ‘Manage’ under ‘Creation default’</li>
                    <li>
                      Under ‘Field defaults’ fill up some of the fields.  
                    </li>
                    <li>
                      Under  ‘Show fields’ disable fields that are not relevant
                      to your team and save.
                    </li>
                  </ol>
                </Col>
                <Col span={12}>
                  <Layout class='video-layout'>
                    <div class='video-container'>
                      <iframe
                        src='https://www.youtube.com/embed/oR2Ctc1OHEA'
                        title='YouTube video player'
                        frameborder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        class='video-content'
                      ></iframe>
                    </div>
                  </Layout>
                </Col>
              </Row>
            </div>
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Test creation form</Text>
                  </div>
                  <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                    <li>
                      Send a message in the project channel you just created in
                      Slack, click on ‘More Actions’ and select ‘Task it’.
                    </li>
                    <li>
                      A model will open up with the fields you already filled up
                      and without the disabled fields. 
                    </li>
                  </ol>
                </Col>
                <Col span={12}>
                  <Layout class='video-layout'>
                    <div class='video-container'>
                      <iframe
                        src='https://www.youtube.com/embed/dR1htKjy4-M'
                        title='YouTube video player'
                        frameborder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        class='video-content'
                      ></iframe>
                    </div>
                  </Layout>
                </Col>
              </Row>
            </div>
          </Carousel>
        )}

        {product === 'projects' && step === 'commands' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Commands</Text>
                </div>
                <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                  <li>
                    Go to the project channel in Slack and enter /t create
                    ‘issue summary’
                  </li>
                  <li>
                    This will create a new issue in Jira and you will also get
                    notified in the Slack channel. 
                  </li>
                </ol>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/nXwUx6rTi_g'
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}

        {product === 'projects' && step === 'emoji_actions' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Emoji actions</Text>
                </div>
                <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                  <li>
                    Drop the : ✅ (white check mark): emoji on any issue message
                    in Slack.
                  </li>
                  <li>
                    This will automatically mark the issue as ‘Done’ and update
                    the same in Jira. 
                  </li>
                </ol>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/cwS1YLAEz8c'
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}

        {product === 'wiki' && step === 'setup_demo_wiki_channel' && (
          <div>
            {page === '1' && (
              <div class='defualt-container'>
                <Row gutter={gutterSize} align='middle'>
                  <Col span={12}>
                    <div class='modal-title-font'>
                      <Text strong>Setup demo wiki channels</Text>
                    </div>
                    <div class='margin-bottom-8'>
                      <Text>
                        This will create a demo wiki channel to automatically
                        answer requests posted in the channel with suggestions
                        from Confluence.
                      </Text>
                    </div>
                    <div>
                      <Text>
                        Click next to connect a Slack channel to Confluence.
                      </Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <img src={Setup_demo_wiki_channels} class='img-width'></img>
                  </Col>
                </Row>
              </div>
            )}
            {page === '2' && (
              <div>
                <div class='modal-title-font'>
                  <Text strong>Add Confluence to Slack channel</Text>
                </div>
                {wikiSkill && (
                  <div>
                    <br />
                    <div>
                      <Text>
                        Create a Slack channel for automatic suggestions from
                        Confluence Space(s). Troopr will automatically find
                        matching Confluence pages for massages posted in
                        configured channels.
                      </Text>
                    </div>
                    <br />
                    <div>
                      <ConfigureWikiChannelModal
                        setClick={(click) =>
                          (this.createDemoWikiChannel = click)
                        }
                        moveToNextStep={(data) => {
                          this.moveToNextStep(data);
                        }}
                        setLoadingState={(loadingState) => {
                          this.setParentLoadingState(loadingState);
                        }}
                      />
                    </div>
                    <br />
                    <div class='margin-bottom-8'>
                      <Text type='warning'>
                        For private channels, ensure Troopr is added to the
                        channel first. Type /invite @troopr in that channel to
                        invite Troopr Assistant.
                      </Text>
                    </div>
                  </div>
                )}
              </div>
            )}
            {page === '3' && (
              <div>
                <div class='modal-title-font'>
                  <Text strong>Success!</Text>
                </div>
                <div style={{ textAlign: 'center', margin: '60px 200px' }}>
                  <img
                    src={SuccessCustomEmoji}
                    style={{ margin: 'auto', marginBottom: '20px' }}
                  />
                  <div class='margin-bottom-8'>
                    {demoChannelsData && (
                      <div>
                        <div style={{ marginBottom: 15 }}>
                          <Text strong>
                            Congratulations on successfully setting up your Wiki
                            channel.{' '}
                            <a
                              onClick={() =>
                                window.open(
                                  `https://slack.com/app_redirect?team=${this.props.team.id}&channel=${demoChannelsData.config.channel.id}`,
                                  '_blank'
                                )
                              }
                            >
                              #{demoChannelsData.config.channel.name}
                            </a>
                          </Text>
                        </div>
                        <div style={{ marginBottom: 15 }}>
                          <Text>
                            Click here to customize{' '}
                            <a
                              onClick={() =>
                                this.props.history.push(
                                  `/${this.props.match.params.wId}/skills/${wikiSkill.skill_metadata._id}?view=channel_preferences&channel_name=${demoChannelsData.config.channel.name}&channel_id=${demoChannelsData.config.channel.id}`
                                )
                              }
                            >
                              Wiki channel
                            </a>{' '}
                            behavior.
                          </Text>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    <Text>
                      Click next to see how Troopr works in this channel.{' '}
                    </Text>
                  </div>
                </div>
              </div>
            )}
            {page === '4' && (
              <div class='defualt-container'>
                <Row gutter={gutterSize} align='middle'>
                  <Col span={12}>
                    <div class='modal-title-font'>
                      <Text strong>Get automatic answering</Text>
                    </div>
                    <div class='margin-bottom-8'>
                      <Text>
                        Go to the Wiki channel and type ‘Meeting notes’. Troopr
                        would automatically send the suggested articles from
                        your Confluence.
                      </Text>
                    </div>
                    <div class='margin-bottom-8'>
                      <Text>
                        If you don't see any suggestions, request for something
                        you have documented in Confluence.{' '}
                      </Text>
                    </div>
                  </Col>
                  <Col span={12}>
                    <Layout class='video-layout'>
                      <div class='video-container'>
                        <iframe
                          src='https://www.youtube.com/embed/K4SIto2tD40'
                          title='YouTube video player'
                          frameborder='0'
                          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                          allowFullScreen
                          class='video-content'
                        ></iframe>
                      </div>
                    </Layout>
                  </Col>
                </Row>
              </div>
            )}
          </div>
        )}

        {product === 'wiki' && step === 'add_to_confluence' && (
          <Carousel
            ref={this.carouselRef}
            dots={false}
            afterChange={() => this.forseUpdateComponenetes()}
          >
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Add to Confluence</Text>
                  </div>
                  <div>
                    <Text>
                      When you don’t have matching articles in Confluence,
                      create articles right in Slack with Troopr. 
                    </Text>
                  </div>
                </Col>
                <Col span={12}>
                  <img src={Add_to_confluence} class='img-width'></img>
                </Col>
              </Row>
            </div>
            <div class='defualt-container'>
              <Row gutter={gutterSize} align='middle'>
                <Col span={12}>
                  <div class='modal-title-font'>
                    <Text strong>Steps to create Confluence article</Text>
                  </div>
                  <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                    <li>Send a message in the wiki channel.</li>
                    <li>
                      [When there is no matching document in Confluence] Reply
                      to the message in the thread. 
                    </li>
                    <li>
                      Add the ‘Book emoji’ on the main message and click on ‘Add
                      to Confluence’ and fill in the form to create the
                      Confluence article. 
                    </li>
                    <li>
                      Send the same message in the wiki channel now. Troopr will
                      suggest the article you just created as an answer to the
                      request. 
                    </li>
                  </ol>
                </Col>
                <Col span={12}>
                  <Layout class='video-layout'>
                    <div class='video-container'>
                      <iframe
                        src='https://www.youtube.com/embed/PjJejmhw8SU'
                        title='YouTube video player'
                        frameborder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        class='video-content'
                      ></iframe>
                    </div>
                  </Layout>
                </Col>
              </Row>
            </div>
          </Carousel>
        )}

        {product === 'wiki' && step === 'search_an_article_privately' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Search an article privately</Text>
                </div>
                <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                  <li>{'Type /t wiki <keyword(s)>.'} </li>
                  <li>
                    Troopr will respond privately to you with the Confluence
                    document(s) matching the keyword. 
                  </li>
                  <li>
                    Click ‘Select action’ in the dropdown next to the relevant
                    document. 
                  </li>
                  <li>
                    Write a message and select a channel to share the document.
                  </li>
                </ol>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/KlsD25GThKM '
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}

        {product === 'reports' && step === 'setup_chart_report' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Setup chart report</Text>
                </div>
                <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                  <li>
                    Go to ‘Channel reports and nudges’ under Reports in Troopr
                    webapp. 
                  </li>
                  <li>Click on ‘Add report’. </li>
                  <li>
                    Select the ‘Issue by status chart’, fill the form and save.
                  </li>
                  <li>
                    The report will be delivered at the configured time in
                    Slack. 
                  </li>
                </ol>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/p_oaWVhX3dw'
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}

        {product === 'reports' && step === 'setup_issue_list_report' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Setup issue list report</Text>
                </div>
                <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                  <li>
                    Go to ‘Channel reports and nudges’ under Reports in Troopr
                    webapp. 
                  </li>
                  <li>Click on ‘Add report’. </li>
                  <li>
                    Select the ‘Issues Progressed Recently’ report, fill the
                    form and save.
                  </li>
                  <li>
                    The report will be delivered at the configured time in
                    Slack. 
                  </li>
                </ol>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/1FAwXuSJLDs'
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}

        {product === 'reports' && step === 'setup_custom_report' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Setup custom report</Text>
                </div>
                <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                  <li>
                    Go to ‘Channel reports and nudges’ under Reports in Troopr
                    webapp. 
                  </li>
                  <li>Click on ‘Add report’. </li>
                  <li>Select the ‘Custom report’, fill the form and save.</li>
                  <li>
                    The report will be delivered at the configured time in
                    Slack.
                  </li>
                </ol>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/ukoU0qw8Yyc '
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}

        {product === 'reports' && step === 'setup_personal_report' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Setup personal report</Text>
                </div>
                <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                  <li>
                    Go to ‘Personal Reports’ under Reports in Troopr webapp. 
                  </li>
                  <li>Click on ‘+Personal report’. </li>
                  <li>
                    Select the ‘Issues by priority’ report, fill the form and
                    save.
                  </li>
                  <li>
                    Go to Troopr Apphome in Slack, make sure ‘Reports’ is
                    selected under the ‘What do you want to see’ section.
                  </li>
                  <li>You can view the report there.</li>
                </ol>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/GxUipDO1Xu0'
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}

        {product === 'checkins' && step === 'setup_standup_checkin' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Setup standup check-in</Text>
                </div>
                <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                  <li>
                    Go to ‘My check-ins’ under ‘Check-ins’ in Troopr webapp.
                  </li>
                  <li>Click on ‘New check-in’ and choose ‘Daily Standup’.</li>
                  <li>
                    The defaults are already set, so go ahead and create the
                    check-in.
                  </li>
                  <li>
                    Click on ‘Run Now’ in the prompt. This will automatically
                    run the check-in.
                  </li>
                </ol>
              </Col>
              <Col span={12}>
                <Layout class='video-layout'>
                  <div class='video-container'>
                    <iframe
                      src='https://www.youtube.com/embed/Zk7QNwA9iBU'
                      title='YouTube video player'
                      frameborder='0'
                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                      allowFullScreen
                      class='video-content'
                    ></iframe>
                  </div>
                </Layout>
              </Col>
            </Row>
          </div>
        )}
        {product === 'checkins' && step === 'submit_standup_answer' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Submit standup answer</Text>
                </div>
                <ol style={{ marginLeft: '-20px' }} class='ol-custom-spacing'>
                  <li>Go to Troopr Assistant App in Slack.</li>
                  <li>
                    Head over to the ‘Messages’ tab. You would have received a
                    check-in notification. 
                  </li>
                  <li>Click on ‘Answer’ in the Check-in prompt. </li>
                  <li>Fill in the details and submit. </li>
                </ol>
                <div>
                  <Text>
                    Once you have submitted the check-in, you will receive the
                    check-in report.
                  </Text>
                </div>
              </Col>
              <Col span={12}>
                <img src={Submit_1st_standup} class='img-width'></img>
              </Col>
            </Row>
          </div>
        )}
        {product === 'checkins' && step === 'integrate_with_jira' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Integrate with Jira</Text>
                </div>
                <ol class='modal-list ol-custom-spacing'>
                  <li>
                    Go to ‘Integrations page’ under Check-ins in Troopr Webapp.
                  </li>
                  <li>Click on ‘Manage’.</li>
                  <li>
                    If you haven’t connected your Jira account yet, choose Cloud
                    or Server/DC connection.
                  </li>
                  <li>Follow the steps to complete the connection.</li>
                </ol>
              </Col>
              <Col span={12}>
                <img src={Integrate_with_jira} class='img-width'></img>
              </Col>
            </Row>
          </div>
        )}
        {product === 'checkins' && step === 'unfurl_jira_issue_mentions' && (
          <div class='defualt-container'>
            <Row gutter={gutterSize} align='middle'>
              <Col span={12}>
                <div class='modal-title-font'>
                  <Text strong>Unfurl Jira issue mentions</Text>
                </div>
                <ol class='modal-list ol-custom-spacing'>
                  <li>Run the standup check-in again.</li>
                  <li>
                    When answering, mention a Jira issue in any one of the
                    answers. Eg: Worked on TT-100
                  </li>
                  <li>
                    Check the report. The report will have unfurled the
                    mentioned Jira issue with a link and summary.
                  </li>
                  <li>
                    You will also get a list of Jira activities in the report.
                  </li>
                </ol>
              </Col>
              <Col span={12}>
                <img
                  src={Share_jira_context_in_reports}
                  class='img-width'
                ></img>
              </Col>
            </Row>
          </div>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  skills: state.skills.skills,
  team: state.skills.team,
});

export default withRouter(connect(mapStateToProps, {})(ModalContent));
